<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Ayuda</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice/expresotec/rides-history" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="form.type=='service'">
    <h2>Ayuda con servicio al cliente</h2>
    <ion-item>
      <ion-label color="primary" position="stacked" #comentarios>Comparte más detalles:</ion-label>
      <ion-textarea
        [(ngModel)]="form.comments"
        [value]="form.comments"
        name="comments"
        (keyup)="updateComments($event)"
      ></ion-textarea>
    </ion-item>
  </div>
  <div *ngIf="form.type=='products'">
    <h2>Ayuda con producto(s)</h2>
    <ion-item>
      <ion-label color="primary" position="stacked" #comentarios>Comparte más detalles:</ion-label>
      <ion-textarea
        [(ngModel)]="form.comments"
        [value]="form.comments"
        name="comments"
        (keyup)="updateComments($event)"
      ></ion-textarea>
    </ion-item>
  </div>
  <div *ngIf="form.type=='invoice'">
    <h2>Ayuda con facturación</h2>
    <ion-item>
      <ion-label color="primary" position="stacked" #comentarios>Comparte más detalles:</ion-label>
      <ion-textarea
        [(ngModel)]="form.comments"
        [value]="form.comments"
        name="comments"
        (keyup)="updateComments($event)"
      ></ion-textarea>
    </ion-item>
  </div>
  <div *ngIf="form.type=='other'">
    <h2>Otro</h2>
    <p>Favor de llenar el siguiente formulario:</p>
    <ion-item lines="none">
      <ion-label color="primary" position="stacked" #comentarios>Comparte más detalles:</ion-label>
      <ion-textarea
        [(ngModel)]="form.comments"
        [value]="form.comments"
        name="comments"
        (keyup)="updateComments($event)"
      ></ion-textarea>
    </ion-item>
  </div>
  <div style="margin-top: 15px">
    <ion-button
      shape="round"
      fill="outline"
      color="primary"
      [disabled]="!form.comments||form.comments==''"
      (click)="send()"
    >
      Enviar
    </ion-button>
  </div>
</ion-content>
